<div class="access-error-container">
  <div class="content">
    <div class="image-no-access-results">
    </div>
    <div class="access-error-header">
       {{ errorMessageHeader }}
    </div>
    <div class="access-error-message">
       {{ errorMessage }}
    </div>
    <div class="button-container">
      <wdpr-button theme="inline-primary" (click)="redirectToLogin()">{{ tryAgain }}</wdpr-button>
    </div>
  </div>
</div>